module.exports = __webpack_public_path__ + "assets/img/1.cc5b6b27.png";